/*
 *
 * App actions
 *
 */

import { actionCreator, stateChangeOnlyActionCreator } from '../store/actionCreators';
import {
  CHANGE_LANGUAGE_ACTIONTYPE,
  CHANGE_MENU_ITEMS_ACTIONTYPE,
  CHECK_ONBOARD_DEVICE_VALID_ACTIONTYPE,
  DEVICE_ONBOARD_FORM_SUBMIT_ACTIONTYPE,
  GET_ROLES_ACTIONTYPE,
  HANDLE_LOGIN_SIDEEFFECT_ACTIONTYPE,
  IS_LOGGED_SUCCESS_ACTIONTYPE,
  LOGGED_OUT_ACTIONTYPE,
  PUBLISH_ERROR_ACTIONTYPE,
  REDIRECT_TO_HOMEPAGE_BASED_ROLE_ACTIONTYPE,
  RESET_APP_DATA_ACTIONTYPE,
  RESET_PASSWORD_ACTIONTYPE,
  SEND_ONBOARD_EMAIL_ACTIONTYPE,
  SET_NOTIF_INTERVAL_ACTIONTYPE,
  SET_NOTIF_SOUND_SETTING_ACTIONTYPE,
  SET_ONBOARD_DEVICE_ID_ACTIONTYPE,
  SET_ONBOARD_SUPERVISOR_ID_ACTIONTYPE,
  SET_SIDE_MENU_OPTIONS_ACTIONTYPE,
  SET_USER_ACTIONTYPE,
  SHOW_CIRCULAR_LOADER_ACTIONTYPE,
  UPDATE_LOGGED_USER_ACTIONTYPE,
  VALIDATE_TOKEN_ACTIONTYPE,
} from './actionTypes';

export const logoutUserAction = actionCreator(LOGGED_OUT_ACTIONTYPE);
export const validateTokenAction = actionCreator(VALIDATE_TOKEN_ACTIONTYPE);
export const resetPasswordAction = actionCreator(RESET_PASSWORD_ACTIONTYPE);
export const getRolesAction = actionCreator(GET_ROLES_ACTIONTYPE);
export const changeLanguuageAction = actionCreator(CHANGE_LANGUAGE_ACTIONTYPE);
export const checkIfOnboardDeviceIsValidAction = actionCreator(CHECK_ONBOARD_DEVICE_VALID_ACTIONTYPE)
export const onboardFormSubmitAction = actionCreator(DEVICE_ONBOARD_FORM_SUBMIT_ACTIONTYPE)
export const sendOnboardEmailAction = actionCreator(SEND_ONBOARD_EMAIL_ACTIONTYPE)

export const isLoginSuccessAction = stateChangeOnlyActionCreator(IS_LOGGED_SUCCESS_ACTIONTYPE);
export const setUserDataAction = stateChangeOnlyActionCreator(SET_USER_ACTIONTYPE);
export const showCircularLoaderAction = stateChangeOnlyActionCreator(SHOW_CIRCULAR_LOADER_ACTIONTYPE);
export const changeMenuItemsAction = stateChangeOnlyActionCreator(CHANGE_MENU_ITEMS_ACTIONTYPE);
export const resetAppDataAction = stateChangeOnlyActionCreator(RESET_APP_DATA_ACTIONTYPE);
export const publishErrorAction = stateChangeOnlyActionCreator(PUBLISH_ERROR_ACTIONTYPE);
export const sideMenuPopulatorAction = stateChangeOnlyActionCreator(SET_SIDE_MENU_OPTIONS_ACTIONTYPE);
export const handleLoginSideEffectAction = stateChangeOnlyActionCreator(HANDLE_LOGIN_SIDEEFFECT_ACTIONTYPE);
export const updateLoggedUserAction = stateChangeOnlyActionCreator(UPDATE_LOGGED_USER_ACTIONTYPE);
export const setNotifIntervalAction = stateChangeOnlyActionCreator(SET_NOTIF_INTERVAL_ACTIONTYPE);
export const setNotifSoundSettingAction = stateChangeOnlyActionCreator(SET_NOTIF_SOUND_SETTING_ACTIONTYPE);
export const redirectToHomePageBasisRoleAction = stateChangeOnlyActionCreator(REDIRECT_TO_HOMEPAGE_BASED_ROLE_ACTIONTYPE);
export const setOnboardDeviceIdAction = stateChangeOnlyActionCreator(SET_ONBOARD_DEVICE_ID_ACTIONTYPE)
export const setOnboardSupervisorIdAction = stateChangeOnlyActionCreator(SET_ONBOARD_SUPERVISOR_ID_ACTIONTYPE)
